import { API_HOST } from "./api.js";
import { $ } from "./dom.js";
import { escapeHtml } from "./escape.js";

function renderStars(rating) {
  const count = Math.min(5, Math.max(0, Math.round(Number(rating) || 5)));
  return Array.from({ length: count }, () => "<span>★</span>").join("");
}

function sanitizeImageSrc(src) {
  if (!src || typeof src !== "string") return "";
  const trimmed = src.trim();
  if (trimmed.startsWith("data:image/")) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return "";
}

function renderTestimonial(item) {
  const quote = escapeHtml(item.quote || "");
  const name = escapeHtml(item.name || "");
  const subtitle = escapeHtml(item.subtitle || "");
  const rating = item.rating ?? 5;
  const src = sanitizeImageSrc(item.imageBase64 || item.imageUrl);
  const imgAlt = escapeHtml(name ? `Zdjęcie: ${name}` : "");

  const img = src
    ? `<img src="${src}" alt="${imgAlt}" width="64" height="64" loading="lazy" class="h-12 w-12 rounded-full object-cover" />`
    : `<span class="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-casto-cloud text-sm font-bold text-casto-navy" aria-hidden="true">${name.charAt(0) || "?"}</span>`;

  return `<figure class="flex flex-col rounded-2xl border border-border/70 bg-white p-7 shadow-soft">
    <div class="flex items-center gap-1 text-casto-orange" aria-label="${rating} z 5 gwiazdek">${renderStars(rating)}</div>
    <blockquote class="mt-4 flex-1 text-[15px] leading-relaxed text-casto-ink">„${quote}”</blockquote>
    <figcaption class="mt-6 flex items-center gap-4 border-t border-border/70 pt-5">
      ${img}
      <div>
        <p class="text-sm font-bold text-casto-ink">${name}</p>
        <p class="text-xs text-muted-foreground">${subtitle}</p>
      </div>
    </figcaption>
  </figure>`;
}

function hideTestimonialsSection(root) {
  const section = root.closest("section") || $("#zaufanie");
  if (section) section.hidden = true;
}

function showTestimonialsSection(root) {
  const section = root.closest("section") || $("#zaufanie");
  if (section) section.hidden = false;
}

export async function loadTestimonials() {
  const root = $("[data-testimonials-root]");
  if (!root) return;

  try {
    const res = await fetch(`${API_HOST}/contractor/testimonials`);
    if (!res.ok) {
      hideTestimonialsSection(root);
      return;
    }
    const data = await res.json();
    const items = data.items || [];
    if (!items.length) {
      hideTestimonialsSection(root);
      return;
    }
    root.innerHTML = items.map(renderTestimonial).join("");
    showTestimonialsSection(root);
  } catch (err) {
    console.error("Testimonials load failed:", err);
    hideTestimonialsSection(root);
  }
}
